import axios from "axios";

const axiosInstance = axios.create({
    baseURL: "https://haider-yt-project.herokuapp.com",
});

export default axiosInstance;
